/* eslint-disable jsx-a11y/media-has-caption */
import { DownloadOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import React from "react";
import { heicToJpg } from "../../../../utils";
import AntdIconV4 from "../../../../utils/antdIcon";
import { mediaDownloader } from "../../../../utils/mediaDownloader";
import "../../../smai-calling/callingComp/callingComp.css";
import { ModalStyled } from "./multipleMediaViewer";

const MediaViewer = props => {
  const { isModalOpen, handleCancel, media, videoThumbnails = [], messageDetails } = props;
  return (
    <ModalStyled
      title="View Video"
      width="97.5%"
      visible={isModalOpen}
      onCancel={handleCancel}
      className="transparent-popup"
      wrapClassName="mediaModal"
      footer={null}
      closeIcon={
        <span className="flex-row-centered gap-2">
          <Tooltip title="Download file">
            <DownloadOutlined
              onClick={e => {
                e.stopPropagation();
                mediaDownloader(media?.mediaUrl, media?.mediaType.split("/")[1]);
              }}
              className="text-white"
            />
          </Tooltip>
          <AntdIconV4 type="CloseOutlined" className="text-white" />
        </span>
      }
    >
      {media?.mediaType.includes("image") ? (
        <img
          src={heicToJpg(media.mediaUrl)}
          alt="nothing"
          width="100%"
          height="500px"
          className="object-contain mt-[10%]"
        />
      ) : (
        <video
          className="w-full h-full"
          controls
          autoPlay
          // poster={videoThumbnails}
        >
          <source src={media?.mediaUrl} type="video/mp4" />
        </video>
        // <h1>Video</h1>
      )}
    </ModalStyled>
  );
};

export default MediaViewer;
